module.exports = __webpack_public_path__ + "static/media/cartEmpty.3cd6182f.svg";